<template>
    <div class="roothome_m">

        <div class="wrapper" style="background-color: white;">
            <!-- ################    Top Menu Bar    ################# -->
            <div align="center" class="head0">
                <div align="center" class="head0_2m">
                    <div class="head1m">
                        <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                    </div>
                    <div class="head2m">
                        <span class="tx_logol" style="font-size: var(--font-size-title-mobile_2);">{{ getInterText(inter_ind.politica_privacidade) }}</span>
                    </div>
                <div  class="head3m">

                </div>
                </div>
            </div>

            <div class="div_expedicao" style=" margin-top: var(--top-bar-heigth)">
                <iframe :src="getPoliticaIdioma()" style="width: 100%; height: 100vh">
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'
    import Slider from '@/components/templates/Slider.vue'

    export default {
        mixins: [advMixin],
        name: 'mExpedicaoAdvice',
        data () {
            return {
                name: 'mExpedicaoAdvice',
                fotoIndex: 0
            }
        },
        components: {
            Slider: Slider
        },
        methods: {
            getPoliticaIdioma() {
                let url = ''

                console.log('getPoliticaIdioma::user idioma: ', this.user.idioma);


                switch (this.user.idioma) {
                    case 1:
                        url = '/static/pages/politicaprivacidade_en.html'
                        break
                    case 2:
                        url = '/static/pages/politicaprivacidade_es.html'
                        break
                    default:
                        url = '/static/pages/politicaprivacidade.html'
                        break
                }
                url = url + '?timestamp=' + new Date().getTime()
                console.log('user: ', this.user)
                console.log('url: ', url);
                return url
            }
        },
        created() {
            console.log(this.name + '::created!!');

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                }
            }

            if (localStorage.getItem('user')) {
                // this.user = localStorage.getItem('user');
                this.user = JSON.parse(localStorage.getItem('user'));
                try {
                    this.user.nome = decodeURIComponent(escape(this.user.nome));
                } catch (e) {
                    this.user.nome = unescape(this.user.nome);
                }
            }

            console.log('created::user idioma: ', this.user.idioma);

            console.log(this.name + '::Terminei o created!!');
        },
        beforeMount() {
            console.log(this.name + '::beforeMount!!');

            console.log(this.name + '::Terminei o beforeMount!!');
        },
        mounted() {
            console.log(this.name + '::mounted::!!');

            console.log(this.name + '::Terminei o mounted!!');
        },
    }
</script>


<style src="../assets/css/adv.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .head0_2 {
        background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));
        /*background-color: var(--bg-header-color);*/
        height: var(--top-bar-heigth);
        width: 100vw;
        display:block;
        margin:auto;
        position:relative;
        font-size: 0;
    }
    .head1, .head2, .head3 {
        height: 100%;
        margin:auto;
        display: inline-block;
        position: relative;
    }
    .head1 {
        width: 15%;
        /*background-color: red;*/
        text-align: left;
    }
    .head2 {
        width: 68%;
        /*background-color: green;*/
        text-align: center;
    }
    .head3 {
        width: 15%;
        /*background-color: aqua;*/
        text-align: right;
    }

    .div_expedicao {
        /*margin: 2vh;*/
        background-color: white;
        background-size: cover;
        color: var(--bg-blue);
        font-size: 2vh;
        display: flex;
        flex-direction: column;
        justify-content: center;

        padding-bottom: 0px;
        margin-bottom: 0px;
        /*background-color: #002b51;*/
    }

</style>



// WEBPACK FOOTER //
// src/components/mPolitica.vue